import React from 'react';

import AdminCardImage from '../admin-card-fields/AdminCardImage/AdminCardImage';
import AdminCardField from '../admin-card-fields/AdminCardField/AdminCardField';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import { FaUser } from 'react-icons/fa';

import './AdminAuthorCard.css';

const AdminAuthorCard = ({
  authorWithPostCount,
  onEditClickHandler,
  onDeleteClickHandler,
}) => {
  const authorFields = [
    { label: 'Name:', value: authorWithPostCount.name, type: 'text' },
    { label: 'Bio:', value: authorWithPostCount.bio, type: 'textarea' },
  ];

  return (
    <div className='admin-blog-author-card-container'>
      <div className='admin-blog-author-top-container'>
        <span>{`Post count: ${authorWithPostCount.postCount}`}</span>
        <div
          className='admin-blog-author-edit-delete-button-container'
          style={{ marginTop: '0px' }}
        >
          <ContentChangeButton
            iconType='edit'
            onClickHandler={() => onEditClickHandler(authorWithPostCount)}
          />
          <ContentChangeButton
            iconType='delete'
            onClickHandler={() => onDeleteClickHandler(authorWithPostCount)}
            isDisabled={authorWithPostCount.postCount > 0}
            disabledMsg={`Cannot delete author that is still associated with blog posts`}
          />
        </div>
      </div>
      <div className='admin-blog-author-content-container'>
        <div className='admin-blog-author-picture-count-container'>
          <div className='admin-blog-author-picture-container'>
            <AdminCardImage
              size='regular'
              img={authorWithPostCount.avatarUrl}
              noImgBox={<FaUser className='admin-blog-author-author-icon' />}
              imgClassName='admin-blog-author-card-image'
            />
          </div>
        </div>
        <div className='admin-blog-author-group'>
          <div className='admin-blog-author-fields-container'>
            {authorFields.map((field, i) => (
              <AdminCardField key={i} label={field.label} type={field.type}>
                {field.value}
              </AdminCardField>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAuthorCard;
